import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#FFDA44\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#0052B4\" d=\"M11.999 24c3.938 0 7.432-1.896 9.62-4.825H2.38A11.98 11.98 0 0 0 11.999 24M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 1.419.247 2.78.7 4.044h22.6c.453-1.264.7-2.625.7-4.044\"></path><path fill=\"#F0F0F0\" d=\"m8.212 7.696.647 1.993h2.096L9.259 10.92l.648 1.992-1.695-1.231-1.696 1.231.648-1.992-1.695-1.232h2.095zM4.614 5.61l.389 1.195H6.26l-1.017.74.389 1.195-1.018-.739-1.017.74.389-1.197-1.017-.739h1.257z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }